<div class="breadcrumbs">
  <div class="breadcrumbs__crumb" *ngFor="let crumb of breadCrumbs">
    <ng-container *ngIf="crumb.link">
      <a [routerLink]="crumb.link" [queryParams]="crumb.queryParams">
        {{ crumb.label }}
      </a>
    </ng-container>
    <ng-container *ngIf="crumb.link === undefined">
      <span>{{ crumb.label }}</span>
    </ng-container>
    <mat-icon>chevron_right</mat-icon>
  </div>
</div>
